/* BW upcoming releases: countdown, brand chips, live check fallback */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCountdown(el) {
    var end = parseInt(el.getAttribute('data-bwx-cd'), 10);
    if (!end) return;
    var short = el.querySelector('.bwx-rel-cd__short');
    var u = {};
    ['d', 'h', 'm', 's'].forEach(function (k) { u[k] = el.querySelector('[data-u="' + k + '"]'); });
    var timer;
    function tick() {
      var diff = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (diff <= 0) {
        el.classList.add('is-done');
        if (short) short.textContent = el.getAttribute('data-done') || '';
        clearInterval(timer);
        return;
      }
      var d = Math.floor(diff / 86400), h = Math.floor(diff % 86400 / 3600), m = Math.floor(diff % 3600 / 60), s = diff % 60;
      if (u.d) u.d.textContent = pad(d);
      if (u.h) u.h.textContent = pad(h);
      if (u.m) u.m.textContent = pad(m);
      if (u.s) u.s.textContent = pad(s);
      if (short) short.textContent = pad(d) + short.getAttribute('data-sd') + ' ' + pad(h) + short.getAttribute('data-sh') + ' ' + pad(m) + short.getAttribute('data-sm');
    }
    tick();
    timer = setInterval(tick, 1000);
  }
  function initChips(root) {
    var chips = root.querySelectorAll('.bwx-rel-chip');
    if (!chips.length) return;
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var b = chip.getAttribute('data-brand');
        chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
        root.querySelectorAll('[data-bwx-month]').forEach(function (month) {
          var any = false;
          month.querySelectorAll('.bwx-rel-row').forEach(function (row) {
            var ok = !b || (b === '__other' ? row.hasAttribute('data-other') : row.getAttribute('data-brand') === b);
            row.hidden = !ok;
            if (ok) any = true;
          });
          month.hidden = !any;
        });
      });
    });
  }
  /* Fallback when no live collection is set: UNLISTED products are not returned by the storefront search,
     so a row whose handle is found there belongs to an ACTIVE product and becomes a link. */
  function toLink(el, url) {
    if (el.tagName === 'A' || !url) return;
    var a = document.createElement('a');
    for (var i = 0; i < el.attributes.length; i++) a.setAttribute(el.attributes[i].name, el.attributes[i].value);
    a.href = url;
    a.classList.add('is-live');
    while (el.firstChild) a.appendChild(el.firstChild);
    el.parentNode.replaceChild(a, el);
    var st = a.querySelector('.bwx-rel-row__state');
    if (st) st.textContent = st.getAttribute('data-live') || '';
  }
  /* Not-live rows carry no handle. Match on the exact title instead and take the URL from the search result. */
  function liveCheck(root) {
    var els = root.querySelectorAll('div.bwx-rel-row[data-t], div.bwx-rel-next[data-t]');
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
    var seen = {};
    function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }
    els.forEach(function (el) {
      var t = el.getAttribute('data-t');
      if (!t) return;
      var p = seen[t] || (seen[t] = fetch(base + 'search/suggest.json?q=' + encodeURIComponent(t) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          var list = j && j.resources && j.resources.results && j.resources.results.products || [];
          var hit = list.filter(function (x) { return norm(x.title) === norm(t); })[0];
          return hit ? hit.url : null;
        }).catch(function () { return null; }));
      p.then(function (url) { toLink(el, url); });
    });
  }
  function init() {
    document.querySelectorAll('[data-bwx-rel]').forEach(function (root) {
      if (root.__bwxRel) return;
      root.__bwxRel = true;
      root.querySelectorAll('[data-bwx-cd]').forEach(initCountdown);
      initChips(root);
      if (root.hasAttribute('data-js-live')) liveCheck(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
